import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";

import { Link, useNavigate } from "react-router-dom";

import { useRecoilState, useRecoilValue } from "recoil";
import { isLoggedInSelector } from "../../actions/Authentication.actions";
import useCookie from "../../hooks/useCookie";
import { postMessageLogout } from "../../internals/asd";
import { webViewSelector } from "../../actions/LayoutMode.actions";
import paths from "../../route/paths";

const ProfileMenu = () => {
  const navigate = useNavigate();

  const [login, setLogin] = useRecoilState(isLoggedInSelector);
  const isWebView = useRecoilValue(webViewSelector);
  const [, setAuthToken] = useCookie("token");
  const [menu, setMenu] = useState<boolean>(false);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item bg-soft-light border-start border-end"
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="avatar-sm d-inline-block align-middle me-2">
            <div
              style={{ fontSize: 64 }}
              className="avatar-title bg-light-subtle text-light font-size-24 m-0 rounded-circle"
            >
              <i className="bx bxs-user-circle"></i>
            </div>
          </div>
          <span className="d-none d-xl-inline-block ms-1 fw-medium">
            {login.profile?.fullname.split(" ")[0]}
          </span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">
          <Link to={"/profile"} className="dropdown-item">
            <i className="bx bx-user font-size-16 align-middle me-1" />{" "}
            {"Profil"}{" "}
          </Link>{" "}
          {/* <Link to={"/contacts-profile"} className="dropdown-item">
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {"Settings"}
          </Link> */}
          <div className="dropdown-divider" />
          <Link
            onClick={() => {
              navigate(paths.AUTHENTICATION.LOGIN);
              setLogin({ isLoggedIn: false });
              isWebView && postMessageLogout("false");
              setAuthToken("", 90);
            }}
            to="#"
            className="dropdown-item"
          >
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />

            <span>{"Çıkış Yap"}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default ProfileMenu;
